<template>
	<search-group
		title="搜索"
		@search="findData"
		@clear="clearValue"
		:span="22"
		:inline="true"
		:btnOffset="20"
		>
		<Row class="mb16" :gutter="16">
			<Col span="4">
				<Select v-model="searchData.labelSecondaryType" placeholder="标签类型">
				<Option value=''>请选择</Option>
				<Option v-for="(item,index) in secondaryType" :key="'s1'+index" :value="item.value">{{item.text}}</Option>
				</Select>
			</Col>
		</Row>
	</search-group>
</template>

<script>
import SearchGroup from 'components/SearchGroup/index';

export default {
	props:{
		secondaryType:{
			type:Array,
			default(){
        return []
      }
		},
	},
	components:{
		SearchGroup
	},
	data(){
		return{
			searchData:{}
		}
	},
	created(){
		this.$emit('search')
	},
	methods:{
		findData(){
			this.$emit('search',this.searchData)
		},
		clearValue(){
			this.searchData = {
				labelSecondaryType:''
			}
		}
	}
}
</script>

<style>

</style>